import { render, staticRenderFns } from "./FlopBox.vue?vue&type=template&id=93855608&scoped=true&"
import script from "./FlopBox.vue?vue&type=script&lang=js&"
export * from "./FlopBox.vue?vue&type=script&lang=js&"
import style0 from "./FlopBox.vue?vue&type=style&index=0&id=93855608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93855608",
  null
  
)

export default component.exports